module.exports = __webpack_public_path__ + "img/photographer_bg.42f663a3.jpg";